module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Homepod-213927356b58f30737565b712ad1b4e9.svg";